module.exports = __webpack_public_path__ + "assets/img/29_289_big.10ecc3f6.jpg";